import React from "react";
import { useProductContext } from "../../context/ProductContext";
import OrderTable from "./OrderTable";

const Order = () => {
  const { order, c_user } = useProductContext();
  const filterOrder = order && order.filter((o) => o.customer.id === c_user.id);

  return (
    <div>
      <div className="page-content">
        <div className="container-fluid">
          <div className="row my-3">
            <div className="col-12">
              <div className="mx-3 my-2 page-title-box d-sm-flex align-items-center justify-content-center">
                <h2
                  style={{
                    textAlign: "center",
                    fontWeight: "bold",
                    marginBottom: "20px",
                  }}
                >
                  MY ORDERS
                </h2>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="card">
                <div className="card-body">
                  <div className="table-responsive">
                    <OrderTable order={filterOrder} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Order;
